module.exports = __webpack_public_path__ + "files/4b28d66ca21d169a901ea428f185d24f.png";